import api from './api';
import type { KensukeFeatureCardId } from '../constants/kensukeFeatureCards';
import { trackGaEvent } from '../utils/analytics';

export interface FeatureEntranceRank {
  featureId: string;
  count: number;
}

export const featureEntranceService = {
  /** カード・サイドバーからの入口クリック（失敗しても UI は継続） */
  async recordEntrance(featureId: KensukeFeatureCardId): Promise<void> {
    trackGaEvent('feature_entrance', {
      feature_id: featureId,
      app_surface: featureId,
    });
    try {
      await api.post('/access-logs/feature-entrance', { featureId });
    } catch (err) {
      if (import.meta.env.DEV) {
        console.warn('[featureEntrance] record failed', err);
      }
    }
  },

  async getRanks(): Promise<FeatureEntranceRank[]> {
    const res = await api.get<{ success: boolean; data: { ranks: FeatureEntranceRank[] } }>(
      '/access-logs/feature-entrance/ranks'
    );
    return res.data?.data?.ranks ?? [];
  },
};

/** ナビ・カードの onClick 用（遷移を阻害しない） */
export function recordFeatureEntrance(featureId: KensukeFeatureCardId): void {
  void featureEntranceService.recordEntrance(featureId);
}
